import { useApplicationLabels } from "~/hooks/useApplicationLabels";
import { createFileRoute } from "@tanstack/react-router";
import JobApplicationsActivitiesPage from "./-pages/activitiesPage";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";

export const Route = createFileRoute("/_dashboard/$datasetSlug/data/applications/activities")({
  component: Component,
});

function Component() {
  const { datasetSlug } = Route.useParams();
  const applicationTerm = useApplicationLabels();
  useBreadCrumbs([
    { title: `${applicationTerm.plural} Activities`, link: `/${datasetSlug}/data/applications/activities` },
  ]);
  return <JobApplicationsActivitiesPage />;
}
